import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-759d171e")

_pushScopeId("data-v-759d171e")
const _hoisted_1 = { class: "hero is-fullheight-with-navbar" }
const _hoisted_2 = { class: "has-text-centered" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: "/img/home/LOGO_final.png",
  class: "logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "subtitle has-text-white" }, [
  /*#__PURE__*/_createTextVNode(" CTFs are the best way the learn Hacking and Cyber Security "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Find like-minded team mates to join the adventure ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: "/img/home/UI_V01_Trait_vertical.svg",
  class: "has-width"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "hero video" }
const _hoisted_8 = { class: "has-text-centered has-margin-bottom" }
const _hoisted_9 = { class: "columns is-vcentered is-multiline has-margin-top-and-right" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "column is-6-tablet" }, [
  /*#__PURE__*/_createVNode("img", { src: "/img/home/IMG_Find_your_hacking_partners_v2.png" })
], -1)
const _hoisted_11 = { class: "column is-6-tablet has-padding" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" If one day you remained blocked on a CTF and wanted to exchange with a mate... but find no one. ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Improve your hacking skills by meeting new players and start to win CTFs and bounties together! ")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = { class: "is-flex is-justify-content-center" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" START NOW ")
const _hoisted_20 = { class: "is-flex is-flex-direction-column is-align-items-center my-6" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" All our Mentors have professionals experiences and well-known certifications. ")
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Match with a hacking coach and ")
const _hoisted_26 = /*#__PURE__*/_createVNode("b", null, " begin your learning adventure.", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Talking with mentors will make you progress in a blink. You will learn faster by following their learning program and apply their advice ")
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("b", null, " LEARN with a mentor - PRACTICE with CTFs - PROGRESS - REPEAT ", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Interested? ")
const _hoisted_38 = { class: "columns" }
const _hoisted_39 = { class: "hero" }
const _hoisted_40 = {
  key: 0,
  class: "is-flex div-cards overflow-auto"
}
const _hoisted_41 = {
  align: "middle",
  class: "has-margin-bottom-and-top"
}
const _hoisted_42 = { class: "columns is-multiline mr-0 has-margin-top" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "column is-6-desktop is-flex is-flex-direction-column is-align-items-center is-justify-content-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "build-image",
    src: "/img/home/Build.svg"
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "hands-image",
    src: "/img/home/main_final.png"
  })
], -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Surround yourself with talented hackers. ")
const _hoisted_46 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" You'll progress in groups, learn new skills,discover new challenges. ")
const _hoisted_48 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Acquire more experiences with your teammates by playing CTFs together & start earning bounties! ")
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" JOIN THE ADVENTURE ")
const _hoisted_54 = {
  class: "hero",
  style: {"margin-top":"3%"}
}
const _hoisted_55 = { class: " " }
const _hoisted_56 = {
  class: "columns is-multiline",
  style: {"margin-right":"0"}
}
const _hoisted_57 = {
  class: "column is-7-desktop ",
  style: {"background-color":"black"}
}
const _hoisted_58 = {
  class: "jointheteam has-text-centered",
  style: {"margin-left":"7%"}
}
const _hoisted_59 = {
  style: {"color":"white","margin-top":"2%"},
  align: "left"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Every month, we'll send you tips to help you learn hacking, testing, and news about the latest cyber attacks. ")
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Also, you will be the first to know about new CTFs on the list. ")
const _hoisted_66 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_68 = {
  class: "column is-5-desktop",
  style: {"color":"white","display":"flex","flex-direction":"column","align-items":"start","justify-content":"center"}
}
const _hoisted_69 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_71 = {
  class: "field",
  style: {"display":"flex"}
}
const _hoisted_72 = /*#__PURE__*/_createVNode("p", { class: "is-flex is-align-items-start" }, " We won't send you spam, we promise ... ", -1)
const _hoisted_73 = {
  key: 0,
  class: "has-text-success",
  "data-testid": "register-valid"
}
const _hoisted_74 = {
  key: 1,
  class: "has-text-danger",
  "data-testid": "register-error"
}
const _hoisted_75 = {
  class: "hero-body",
  style: {"margin-top":"5%"}
}
const _hoisted_76 = { class: "container has-text-centered" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" @Cohackers 2021 ")
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" GTC ")
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" All rights reserved ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ctf_card = _resolveComponent("ctf-card")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", {
      class: "hero head is-flex is-justify-content-space-around",
      style: {
        background:
          _ctx.windowWidth < 768
            ? 'no-repeat url(/img/home/background_mobile.jpg)'
            : 'no-repeat url(/img/home/background_img.jpg)',
        backgroundSize: '100% auto',
        minWidth: '100%'
      }
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode("button", {
          class: "is-align-items-center is-justify-content-center has-text-white has-text-weight-bold start-button",
          style: {
            height: _ctx.windowWidth <= 768 ? '50px' : '60px',
            fontSize:
              _ctx.windowWidth <= 768
                ? '110%'
                : _ctx.windowWidth <= 1200
                ? '135%'
                : '180%'
          },
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
        }, " START ", 4)
      ])
    ], 4),
    _createVNode("section", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("p", {
              class: "has-text-white",
              style: {
                fontSize:
                  _ctx.windowWidth <= 950
                    ? '18px'
                    : _ctx.windowWidth <= 1215
                    ? '25px'
                    : '30px'
              },
              align: "left"
            }, [
              _hoisted_12,
              _hoisted_13,
              _hoisted_14
            ], 4),
            _createVNode("p", {
              class: "has-text-white has-text-weight-bold",
              style: {
                fontSize:
                  _ctx.windowWidth <= 950
                    ? '20px'
                    : _ctx.windowWidth <= 1215
                    ? '25px'
                    : '30px'
              },
              align: "left"
            }, " THIS PLATFORM IS FOR YOU ", 4),
            _createVNode("p", {
              class: "has-text-white",
              style: {
                fontSize:
                  _ctx.windowWidth <= 950
                    ? '18px'
                    : _ctx.windowWidth <= 1215
                    ? '25px'
                    : '30px'
              },
              align: "left"
            }, [
              _hoisted_15,
              _hoisted_16
            ], 4),
            _hoisted_17,
            _createVNode("a", _hoisted_18, [
              _createVNode("button", {
                class: "is-flex is-justify-content-center is-align-items-center has-text-weight-bold start-now-button",
                style: {
                  height: _ctx.windowWidth <= 768 ? '50px' : '60px',
                  fontSize:
                    _ctx.windowWidth <= 768
                      ? '110%'
                      : _ctx.windowWidth <= 1200
                      ? '135%'
                      : '180%'
                },
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
              }, [
                _hoisted_19,
                _createVNode("img", {
                  style: {
                    width:
                      _ctx.windowWidth <= 500
                        ? '6vw'
                        : _ctx.windowWidth <= 768
                        ? '5vw'
                        : '3vw',
                    marginLeft: '15px'
                  },
                  src: "/img/home/Arrow_in_button.svg"
                }, null, 4)
              ], 4)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_20, [
      _createVNode("img", {
        src: 
          _ctx.windowWidth <= 768
            ? _ctx.MENTORING_MOBILE_IMAGE_URL
            : _ctx.MENTORING_DESKTOP_IMAGE_URL
        ,
        alt: "mentoring",
        style: { width: _ctx.windowWidth <= 768 ? '95%' : '65%' }
      }, null, 12, ["src"]),
      _createVNode("p", {
        class: "has-text-centered",
        style: {
          fontSize:
            _ctx.windowWidth <= 950 ? '18px' : _ctx.windowWidth <= 1215 ? '25px' : '30px'
        }
      }, [
        _createVNode("b", {
          style: {
            fontSize:
              _ctx.windowWidth <= 950
                ? '20px'
                : _ctx.windowWidth <= 1215
                ? '25px'
                : '30px'
          }
        }, " MENTORING IS KEY! ", 4),
        _hoisted_21,
        _hoisted_22,
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _hoisted_26,
        _hoisted_27,
        _hoisted_28,
        _createVNode("b", {
          style: {
            fontSize:
              _ctx.windowWidth <= 950
                ? '20px'
                : _ctx.windowWidth <= 1215
                ? '25px'
                : '30px'
          }
        }, " WHY MENTORING? ", 4),
        _hoisted_29,
        _hoisted_30,
        _hoisted_31,
        _hoisted_32,
        _hoisted_33,
        _hoisted_34,
        _hoisted_35,
        _hoisted_36,
        _hoisted_37
      ], 4),
      _createVNode("div", _hoisted_38, [
        _createVNode("button", {
          class: "column is-flex is-justify-content-center is-align-items-center has-text-weight-bold start-now-button",
          style: {
            padding: _ctx.windowWidth <= 768 ? '3px' : '45px',
            height: _ctx.windowWidth <= 768 ? '50px' : '60px',
            fontSize:
              _ctx.windowWidth <= 768
                ? '110%'
                : _ctx.windowWidth <= 1200
                ? '135%'
                : '180%'
          },
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
        }, " JOIN THE ADVENTURE ", 4),
        _createVNode("button", {
          class: "column is-flex is-justify-content-center is-align-items-center has-text-weight-bold become-a-mentor-button",
          style: {
            padding: _ctx.windowWidth <= 768 ? '3px' : '45px',
            height: _ctx.windowWidth <= 768 ? '50px' : '60px',
            fontSize:
              _ctx.windowWidth <= 768
                ? '110%'
                : _ctx.windowWidth <= 1200
                ? '135%'
                : '180%'
          },
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBecomeAMentorClick && _ctx.onBecomeAMentorClick(...args)))
        }, " BECOME A MENTOR ", 4)
      ])
    ]),
    _createVNode("section", _hoisted_39, [
      _createVNode("img", {
        src: 
          _ctx.windowWidth <= 768 ? _ctx.DISCOVER_MOBILE_IMAGE : _ctx.DISCOVER_DESKTOP_IMAGE
        
      }, null, 8, ["src"]),
      _createVNode("div", {
        style: { marginLeft: _ctx.windowWidth <= 535 ? 0 : '20%' }
      }, [
        (_ctx.ctfCards && _ctx.ctfCards.findCtf)
          ? (_openBlock(), _createBlock("div", _hoisted_40, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ctfCards.findCtf, ({ id, image, title, members, url }) => {
                return (_openBlock(), _createBlock("div", {
                  key: id,
                  class: " column is-12-mobile is-6-tablet is-4-widescreen is-3-fullhd"
                }, [
                  _createVNode(_component_ctf_card, {
                    id: id,
                    image: image,
                    title: title,
                    members: members,
                    url: 
                url.length > 26
                  ? `${url.substr(0, 15)}...${url.substr(url.length - 8)}`
                  : url
              ,
                    "data-testid": "ctf-card"
                  }, null, 8, ["id", "image", "title", "members", "url"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 4),
      _createVNode("div", _hoisted_41, [
        _createVNode("p", {
          class: "has-text-weight-normal title has-text-white",
          style: {
            fontSize:
              _ctx.windowWidth <= 950
                ? '18px'
                : _ctx.windowWidth <= 1215
                ? '25px'
                : '30px'
          }
        }, " Find new challenging CTFs. ", 4),
        _createVNode("button", {
          class: "discover-button",
          style: {
            height: _ctx.windowWidth <= 768 ? '50px' : '60px',
            fontSize:
              _ctx.windowWidth <= 768
                ? '110%'
                : _ctx.windowWidth <= 1200
                ? '135%'
                : '180%'
          },
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
        }, " DISCOVER ", 4)
      ])
    ]),
    _createVNode("section", null, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_42, [
          _hoisted_43,
          _createVNode("div", {
            class: "column is-6-desktop",
            style: {
              padding: _ctx.windowWidth <= 1410 ? '8%' : '3%',
              paddingTop: _ctx.windowWidth <= 1410 ? '0' : '4%'
            }
          }, [
            _createVNode("p", {
              class: "has-text-weight-bold has-text-right has-color",
              style: {
                fontSize:
                  _ctx.windowWidth <= 768
                    ? '30px'
                    : _ctx.windowWidth <= 1410
                    ? '25px'
                    : '40px'
              }
            }, " FIND LIKE-MINDED TEAMMATES TO JOIN THE ADVENTURE ", 4),
            _hoisted_44,
            _createVNode("p", {
              class: "has-text-right has-text-white  ",
              style: {
                fontSize:
                  _ctx.windowWidth <= 950
                    ? '18px'
                    : _ctx.windowWidth <= 1215
                    ? '25px'
                    : '30px'
              }
            }, [
              _hoisted_45,
              _hoisted_46,
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              _hoisted_50
            ], 4),
            _hoisted_51,
            _createVNode("div", _hoisted_52, [
              _createVNode("button", {
                class: "is-flex is-align-items-center is-justify-content-center has-text-weight-bold start-now-button",
                style: {
                  height: _ctx.windowWidth <= 768 ? '50px' : '60px',
                  fontSize:
                    _ctx.windowWidth <= 352
                      ? '15px'
                      : _ctx.windowWidth <= 807
                      ? '20px'
                      : _ctx.windowWidth <= 1247
                      ? '22px'
                      : _ctx.windowWidth <= 1275
                      ? '24px'
                      : '30px'
                },
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggle-sign-up')))
              }, [
                _hoisted_53,
                _createVNode("img", {
                  class: "ml-4",
                  style: {
                    width:
                      _ctx.windowWidth <= 500
                        ? '6vw'
                        : _ctx.windowWidth <= 768
                        ? '5vw'
                        : '3vw'
                  },
                  src: "/img/home/Arrow_in_button.svg"
                }, null, 4)
              ], 4)
            ])
          ], 4)
        ])
      ])
    ]),
    _createVNode("section", _hoisted_54, [
      _createVNode("div", _hoisted_55, [
        _createVNode("div", _hoisted_56, [
          _createVNode("div", _hoisted_57, [
            _createVNode("div", _hoisted_58, [
              _createVNode("div", _hoisted_59, [
                _createVNode("p", {
                  class: "has-padding-top",
                  style: {
                    fontSize:
                      _ctx.windowWidth <= 950
                        ? '18px'
                        : _ctx.windowWidth <= 1215
                        ? '25px'
                        : '30px'
                  }
                }, [
                  _hoisted_60,
                  _hoisted_61,
                  _hoisted_62,
                  _hoisted_63,
                  _hoisted_64,
                  _hoisted_65,
                  _hoisted_66,
                  _hoisted_67
                ], 4)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_68, [
            _createVNode("div", {
              class: "has-margin-left",
              style: {
                marginTop: _ctx.windowWidth <= 600 ? '-18%' : '-5%'
              }
            }, [
              _hoisted_69,
              _hoisted_70,
              _createVNode("p", {
                class: "is-flex is-align-items-start",
                style: {
                  fontSize:
                    _ctx.windowWidth <= 768
                      ? '23px'
                      : _ctx.windowWidth <= 1215
                      ? '25px'
                      : '35px'
                }
              }, " What's your email address? ", 4),
              _createVNode("div", _hoisted_71, [
                _withDirectives(_createVNode("input", {
                  class: "input-newsletter",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.email = $event)),
                  type: "email",
                  "data-testid": "newsletter-email-input",
                  style: {
                    fontSize:
                      _ctx.windowWidth <= 600
                        ? '17px'
                        : _ctx.windowWidth <= 1023
                        ? '20px'
                        : _ctx.windowWidth <= 1215
                        ? '25px'
                        : '30px'
                  },
                  placeholder: "youremail@email.com"
                }, null, 4), [
                  [_vModelText, _ctx.email]
                ]),
                _createVNode("img", {
                  class: "newsletter-enter",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.newsletter && _ctx.newsletter(...args))),
                  "data-testid": "registerNewsletter-submit-button",
                  src: "/img/home/Icon_enter.svg"
                })
              ]),
              _hoisted_72,
              (_ctx.register == 'success')
                ? (_openBlock(), _createBlock("div", _hoisted_73, " Email correctly registered "))
                : (_ctx.register == 'Email already registered')
                  ? (_openBlock(), _createBlock("div", _hoisted_74, " Email already registered "))
                  : _createCommentVNode("", true)
            ], 4)
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_75, [
      _createVNode("div", _hoisted_76, [
        _createVNode("h6", null, [
          _hoisted_77,
          _createVNode(_component_router_link, { to: "/gtc" }, {
            default: _withId(() => [
              _hoisted_78
            ]),
            _: 1
          }),
          _hoisted_79
        ])
      ])
    ])
  ]))
})